// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"_24h6PR6u6tTSbakvoKSR7l"};